<template>
  <div class>
    <sweet-modal ref="modal" width="900px" hide-close-button blocking>
      <p class="popup-save-title">{{ this.$t('ct-save-free-whitout-domain-title') }} </p>
      <p class="popup-save-message">
        {{ this.$t('ct-save-free-whitout-domain-message') }}
      </p>
      <div class="button-container">
        <div class="domain-connected">
          <p class="domain-text" style="width: 70%"> {{ domain }} </p>
          <a style="wrap: no-wrapp" :href="domain" target="_blank" class="btn btn-dark">{{ this.$t('ct-go-to-website') }}</a>
        </div>
      </div>
      <button @click="upgrade()" class="btn btn-primary btn-lg popup-save-btn-buy-domain">{{ this.$t('ct-i-want-connect-my-domain') }}</button>
      <button slot="button" @click="closeAction" class="btn btn-outline-light mt-2 btn-publish">{{ this.$t('ct-i-am-satisfied-domain') }} </button>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
export default {
  props: ['show', 'domain'],
  name: 'ModalPublishFreeComponent',
  components: {
    SweetModal
  },
  data() {
    return {
      myInterval : '',
      timeLeft: 10,
      disabled: 1
    };
  },
  watch: {
    show: function(value) {
      if(localStorage.getItem('is_bundle') != 'exit-popup'){
        if (value){
          this.$refs.modal.open();
        } else {
          this.$refs.modal.close();
        }
      }
    }
  },
  methods: {
    closeAction(){
      this.$emit('closeAction');
    },
    upgrade(){
      this.$emit('upgrade');
    }
  }
};
</script>

<style lang="scss" scoped>

.domain-connected{
  margin-top: 30px;
      margin-bottom: 30px;
      width: 100%;
      border-radius: 5px;
      background: #FFF 0% 0% no-repeat padding-box;
      display: flex;
      // flex-direction: row;
      align-items: center;
     justify-content: flex-start;
}

.domain-text{
  margin-left: 30px;
  font-family: 'Lato';
  font-size: 20px;
  color: #434343;
}

// .btn-dark{
//   background-color: #5A5959;
// }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalPublishFree.vue